import { useState } from "react";
import { masterSupabase } from "../lib/supabase.js";
import Signup from "./Signup.jsx";

const iS = { width: "100%", padding: "10px 14px", marginBottom: 12, background: "#06060a", border: "1px solid #1f1f3a", borderRadius: 8, color: "#e0e0e0", fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "inherit" };

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState("password"); // password | magic
    const [magicSent, setMagicSent] = useState(false);
    const [showSignup, setShowSignup] = useState(false);

    const [resetSent, setResetSent] = useState(false);

    const handleForgotPassword = async () => {
        if (!email.trim()) { setError("Enter your email first, then click Forgot Password."); return; }
        setLoading(true); setError(null);
        const { error } = await masterSupabase.auth.resetPasswordForEmail(email, {
            redirectTo: window.location.origin + "/",
        });
        if (error) setError(error.message);
        else setResetSent(true);
        setLoading(false);
    };

    const handlePasswordLogin = async (e) => {
        e.preventDefault();
        setLoading(true); setError(null);
        const { error } = await masterSupabase.auth.signInWithPassword({ email, password });
        if (error) setError(error.message);
        setLoading(false);
    };

    const handleMagicLink = async (e) => {
        e.preventDefault();
        if (!email.trim()) { setError("Please enter your email."); return; }
        setLoading(true); setError(null);
        const { error } = await masterSupabase.auth.signInWithOtp({
            email,
            options: { emailRedirectTo: window.location.origin },
        });
        if (error) setError(error.message);
        else setMagicSent(true);
        setLoading(false);
    };

    if (showSignup) return <Signup onBack={() => setShowSignup(false)} />;

    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#08080c" }}>
            <div style={{ width: 380, padding: 36, background: "#0d0d12", borderRadius: 16, border: "1px solid #1f1f3a" }}>
                <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4, color: "#e0e0e0" }}>Clarifico</h1>
                <p style={{ fontSize: 13, color: "#555", marginBottom: 28 }}>Sign in to your dashboard</p>

                {magicSent || resetSent ? (
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                        <div style={{ fontSize: 32, marginBottom: 12 }}>{resetSent ? "🔑" : "✉️"}</div>
                        <div style={{ fontSize: 15, color: "#ccc", fontWeight: 600, marginBottom: 8 }}>Check your email</div>
                        <div style={{ fontSize: 13, color: "#888", lineHeight: 1.6 }}>
                            {resetSent
                                ? <>We sent a password reset link to <strong style={{ color: "#ccc" }}>{email}</strong>. Click the link to set a new password.</>
                                : <>We sent a sign-in link to <strong style={{ color: "#ccc" }}>{email}</strong>. Click the link in your email to access your dashboard.</>
                            }
                        </div>
                        <button onClick={() => { setMagicSent(false); setResetSent(false); setMode("password"); }} style={{ marginTop: 20, padding: "8px 16px", background: "none", border: "1px solid #1f1f3a", borderRadius: 8, color: "#888", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>Back to sign in</button>
                    </div>
                ) : mode === "password" ? (
                    <form onSubmit={handlePasswordLogin}>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" style={iS} />
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" style={iS} />
                        {error && <p style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{error}</p>}
                        <button type="submit" disabled={loading} style={{ width: "100%", padding: "10px 0", background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", marginBottom: 12 }}>{loading ? "Signing in..." : "Sign In"}</button>
                        <div style={{ display: "flex", gap: 8, marginBottom: 0 }}>
                            <button type="button" onClick={() => { setMode("magic"); setError(null); }} style={{ flex: 1, padding: "9px 0", background: "none", border: "1px solid #1f1f3a", borderRadius: 8, color: "#888", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>Email link instead</button>
                            <button type="button" onClick={handleForgotPassword} disabled={loading} style={{ flex: 1, padding: "9px 0", background: "none", border: "1px solid #1f1f3a", borderRadius: 8, color: "#888", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>Forgot password?</button>
                        </div>
                        <div style={{ marginTop: 16, textAlign: "center" }}>
                            <button type="button" onClick={() => setShowSignup(true)} style={{ background: "none", border: "none", color: "#6366f1", fontSize: 13, cursor: "pointer", fontFamily: "inherit", fontWeight: 600 }}>Create a new account</button>
                        </div>
                    </form>
                ) : (
                    <form onSubmit={handleMagicLink}>
                        <p style={{ fontSize: 13, color: "#888", marginBottom: 16, lineHeight: 1.5 }}>Enter your email and we'll send you a sign-in link. No password needed.</p>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" style={iS} />
                        {error && <p style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{error}</p>}
                        <button type="submit" disabled={loading} style={{ width: "100%", padding: "10px 0", background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", marginBottom: 12 }}>{loading ? "Sending..." : "Send Sign-In Link"}</button>
                        <button type="button" onClick={() => { setMode("password"); setError(null); }} style={{ width: "100%", padding: "9px 0", background: "none", border: "1px solid #1f1f3a", borderRadius: 8, color: "#888", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>Sign in with password instead</button>
                    </form>
                )}
            </div>
        </div>
    );
}